<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
      <el-breadcrumb-item>我的工作台</el-breadcrumb-item>
      <el-breadcrumb-item>项目预决算</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择项目" class="select" style="width: 150px;">
              <el-option label="请选择项目" value="0"></el-option>
              <el-option
                v-for="item in projectlist" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Projectname" label="项目" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Jigouname" label="部门" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projecttime" label="日期" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectproductname" label="品名" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectyujiprice" label="预算单价" header-align="center" align="center" min-width="6%"></el-table-column>
          <el-table-column prop="Projectnum" label="数量" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Projectyujidays" label="预计完成天数" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectshijidays" label="实际完成时间" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectsuppliername" label="供应商名称" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Projectphone" label="联系电话" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Projectshijiprice" label="实际支付单价" header-align="center" align="center" min-width="9%"></el-table-column>
          <el-table-column prop="Projectpaystatuss" label="是否支付" header-align="center" align="center" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" header-align="center" align="center" min-width="10%"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdelete(scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="8"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="180px">
          <el-form-item label="">
            <label slot="label">
              <span style="color: #FF0000;">项目(必填)</span>
            </label>
            <el-select v-model="addData.bomsn" placeholder="请选择项目" class="select" style="width: 150px;">
              <el-option
                v-for="item in projectlist" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">日期(必填)</span>
            </label>
            <el-date-picker v-model="addData.projecttime" type="date" placeholder="选择月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="品名(选填)" class="addAdminForm">
            <el-input v-model="addData.projectproductname" placeholder="请输入品名"></el-input>
          </el-form-item>
          <el-form-item label="预算单价(选填)" class="addAdminForm">
            <el-input v-model="addData.projectyujiprice" placeholder="请输入预算单价"></el-input>
          </el-form-item>
          <el-form-item label="数量(选填)" class="addAdminForm">
            <el-input v-model="addData.projectnum" placeholder="请输入数量"></el-input>
          </el-form-item>
          <el-form-item label="预计完成天数(选填)" class="addAdminForm">
            <el-input v-model="addData.projectyujidays" placeholder="请输入预计完成天数"></el-input>
          </el-form-item>
          <el-form-item label="实际完成时间(选填)" class="addAdminForm">
            <el-input v-model="addData.projectshijidays" placeholder="请输入实际完成时间"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称(选填)" class="addAdminForm">
            <el-input v-model="addData.projectsuppliername" placeholder="请输入供应商名称"></el-input>
          </el-form-item>
          <el-form-item label="联系电话(选填)" class="addAdminForm">
            <el-input v-model="addData.projectphone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="实际支付单价(选填)" class="addAdminForm">
            <el-input v-model="addData.projectshijiprice" placeholder="请输入实际支付单价"></el-input>
          </el-form-item>
          <el-form-item label="是否支付(选填)" class="addAdminForm">
            <el-select v-model="addData.projectpaystatus" placeholder="请选择" class="select" style="width: 150px;">
              <el-option label="未支付" value="0"></el-option>
              <el-option label="已支付" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <WorkprojectbudgetChange ref="SubVuesecond" v-on:triggerFunc="clickreturn"></WorkprojectbudgetChange>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import WorkprojectbudgetChange from '@/componentsSubVue/WorkprojectbudgetChange.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    WorkprojectbudgetChange
  },
  name: 'MyWorkprojectbudget',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      projectlist: [],
      // 筛选条件
      keywords: {
        bomsn: '103-0000-0002'
      },
      // 添加
      addData: {
        bomsn: '103-0000-0002',
        projecttime: '',
        projectproductname: '',
        projectyujiprice: '0',
        projectnum: '1',
        projectyujidays: '',
        projectshijidays: '',
        projectsuppliername: '',
        projectphone: '',
        projectshijiprice: '0',
        projectpaystatus: '0'
      }
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
    this.apiGetWorkprojectbudgetNum()
    this.apiGetWorkprojectbudgetList()
    this.addData.projecttime = Vue.prototype.FunGetTimeStringShortFirst()
  },
  methods: {
    clickreturn () {
      this.activeName = 'first'
      this.apiGetWorkprojectbudgetNum()
      this.apiGetWorkprojectbudgetList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetWorkprojectbudgetList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetWorkprojectbudgetNum()
      this.apiGetWorkprojectbudgetList()
    },
    clickadd () {
      this.apiAddWorkprojectbudget()
    },
    clickdelete (row) {
      this.$confirm('是否删除此预决算?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteWorkprojectbudget(row)
      })
    },
    clickedit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row, this.projectlist)
    },
    apiGetWorkprojectbudgetList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectbudgetList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkprojectbudgetNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectbudgetNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddWorkprojectbudget: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: that.addData.bomsn,
        projecttime: that.addData.projecttime,
        projectproductname: that.addData.projectproductname,
        projectyujiprice: that.addData.projectyujiprice,
        projectnum: that.addData.projectnum,
        projectyujidays: that.addData.projectyujidays,
        projectshijidays: that.addData.projectshijidays,
        projectsuppliername: that.addData.projectsuppliername,
        projectphone: that.addData.projectphone,
        projectshijiprice: that.addData.projectshijiprice,
        projectpaystatus: that.addData.projectpaystatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddWorkprojectbudget, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.bomsn = '103-0000-0002'
            that.addData.projecttime = ''
            that.addData.projectproductname = ''
            that.addData.projectyujiprice = '0'
            that.addData.projectnum = '1'
            that.addData.projectyujidays = ''
            that.addData.projectshijidays = ''
            that.addData.projectsuppliername = ''
            that.addData.projectphone = ''
            that.addData.projectshijiprice = '0'
            that.addData.projectpaystatus = '0'

            that.apiGetWorkprojectbudgetNum()
            that.apiGetWorkprojectbudgetList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteWorkprojectbudget: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        workprojectbudgetid: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteWorkprojectbudget, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetWorkprojectbudgetNum()
            that.apiGetWorkprojectbudgetList()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.projectlist = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype <= 1) {
              	that.projectlist.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

  .item {
    margin-top: 10px;
    margin-right: 40px;
  }

/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}

.box-cardprimary{
    margin-top: 0px;
    background: #409eff;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-cardwarning{
    margin-top: 0px;
    background: #ebb562;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-carddanger{
    margin-top: 0px;
    background: #f56c6c;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#ffffff;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
        color:#ffffff;
    }
}
</style>
